import { Redirect } from 'react-router-dom';
import { PLACEMENT, Link } from './types';
import Dashboard from './pages/Dashboard';
import PlayerList from './pages/PlayerList';
import PlayerDashboard from './pages/PlayerDashboard';
import GenericAddForm from './pages/GenericAddEditForm';
import PlayerCardDetail from './pages/PlayerCardDetail';
import TeamMembers from '../components/containers/team-members/team-members';
import MetabaseDashboard from '../components/containers/metabase-dashboard/metabase-dashboard';
import TherapyRefusalDashboard from './pages/TherapyRefusalDashboard';
import PlayerArchive from '../components/containers/player-archive/player-archive';
import AdminDashboardRedirect from './utils/adminDashboardRedirect';
import TeamMemberForm from '../components/containers/team-member-form/team-member-form';
import LogOut from './pages/LogOut';
import TournamentCreator from '../components/containers/tournament-creator/tournament-creator';
import TournamentEditor from '../components/containers/tournament-creator/tournament-editor';
import IframeWebcore from '../components/containers/webcore_iframe/iframe-webcore';
import CommunicationCreator from '../components/containers/communication-creator/communication-creator';
import CommunicationEditor from '../components/containers/communication-creator/communication-editor';
import MasqueradePage from './pages/MasqueradePage';
import MarbleRedirect from './utils/marbleRedirect';
import ResetPassword from './pages/ResetPassword';
import PlayerRewards from './pages/PlayerRewards';
import SessionDesigner from '../components/containers/session-designer/session-designer';
import TherapistSessionBank from '../components/containers/therapist-session-bank/therapist-session-bank';
import PlayerForm from '../components/containers/player-form/player-form';
import PlayerGameSession from '../components/containers/player-game-session/player-game-session';
import PlayerGameSessions from '../components/containers/player-game-sessions/player-game-sessions';
import ResultsDashboard from '../components/containers/player-activities/player-activities';
import PlayerProgressDashboard from '../components/containers/player-progress-dashboard/player-progress-dashboard';
import PlayerSessionBank from '../components/containers/player-session-bank/player-session-bank';
import PlayerTeamMembers from '../components/containers/player-team-members/player-team-members';
import HomePlay from '../components/containers/home-play/home-play';
import PasswordSuccess from './pages/PasswordSuccess';
import SsoRedirect from './utils/ssoRedirect';
import Cboard from './components/Cboard';
import Wellness from './components/Wellness';
import RegionalManagerDashboard from '../components/containers/manager-dashboard/regional-manager-dashboard';
import SecurityDashboard from './pages/SecurityDashboard';
import OTP from './pages/OTP';
import HomePlayerDashboard from './pages/HomePlayerDashboard';
import RestorativePlayerList from './pages/RestorativePlayerList';

import splitsDictionary from '../services/utils/splitsDictionary';
import RemoteTherapySession from './pages/RemoteTherapySession';

import { MixPanelEventTypes, PlatformTypes } from './services/MixPanel';
import InterventionLaunch from './components/Intervention';

export const routes = (currentUserId: number): Link[] => {
  return [
    {
      component: RegionalManagerDashboard,
      exact: true,
      label: 'Manage',
      path: '/dashboard',
      claim: 'user::business-group-admin-dashboard::*',
      placement: PLACEMENT.NAVBAR,
      to: '/dashboard',
    },
    {
      component: MetabaseDashboard,
      exact: true,
      label: 'Stats',
      path: '/stats-dashboard',
      claim: 'user::business-group-analytics::*',
      placement: PLACEMENT.NAVBAR,
      to: '/stats-dashboard',
    },
    {
      component: TherapyRefusalDashboard,
      exact: true,
      label: 'Refusals',
      path: '/refusal-tracker',
      claim: 'user::business-group-analytics::*',
      placement: PLACEMENT.NAVBAR,
      to: '/refusal-tracker',
    },
    {
      component: TeamMemberForm,
      label: 'Profile',
      path: '/profile/:id',
      claim: 'user::profile::*',
      placement: PLACEMENT.DROPDOWN,
      to: `/profile/${currentUserId || ''}`,
    },
    {
      component: OTP,
      label: 'OTP Phone Number Change',
      path: '/otp/change',
      claim: 'user::profile::*',
      placement: PLACEMENT.NONE,
      to: `/otp/change`,
    },
    {
      component: Dashboard,
      exact: true,
      label: 'Dashboard',
      path: '/dashboard',
      claim: 'user::dashboard::*',
      placement: PLACEMENT.NAVBAR,
      to: '/dashboard',
      mixPanelEvent: {
        name: 'Therapy_SkillsUI_NavigationBar_Click',
        data: {
          Selection: 'Dashboard',
        },
      },
    },
    {
      component: HomePlayerDashboard,
      label: 'Home',
      path: '/dashboard',
      exact: true,
      claim: 'player::dashboard::*',
      placement: PLACEMENT.NAVBAR,
      to: '/dashboard',
      noMainPadding: true,
    },
    {
      component: PlayerList,
      exact: true,
      label: 'My Players',
      path: '/players',
      claim: 'user::player::*',
      placement: PLACEMENT.NAVBAR,
      to: '/players',
      mixPanelEvent: {
        name: 'Therapy_SkillsUI_NavigationBar_Click',
        data: {
          Selection: 'My Players',
        },
      },
    },
    {
      path: '/therapistDashboard',
      component: () => {
        return <Redirect to="/players" />;
      },
      placement: PLACEMENT.NONE,
      claim: 'user::player::*',
    },
    {
      path: '/gameSession',
      component: SessionDesigner,
      placement: PLACEMENT.NONE,
      claim: 'user::player::*',
      exact: true,
    },
    {
      path: '/sessionBank',
      component: TherapistSessionBank,
      placement: PLACEMENT.NONE,
      claim: 'user::player::*',
      exact: true,
    },
    {
      path: '/gameSession/:id',
      component: SessionDesigner,
      placement: PLACEMENT.NONE,
      claim: 'user::player::*',
    },
    {
      exact: true,
      path: '/player',
      component: PlayerForm,
      placement: PLACEMENT.NONE,
      claim: 'user::player::*',
    },
    {
      exact: true,
      path: '/player/:id',
      component: PlayerForm,
      placement: PLACEMENT.NONE,
      claim: 'user::player::*',
    },
    {
      exact: true,
      path: '/player/:id/sessions',
      component: PlayerGameSessions,
      placement: PLACEMENT.NONE,
      claim: 'user::player::*',
    },
    {
      exact: true,
      path: '/player/:id/sessions/:player_game_session_id',
      component: PlayerGameSession,
      placement: PLACEMENT.NONE,
      claim: 'user::player::*',
    },
    {
      exact: true,
      path: '/player/:playerId/gameSession',
      component: SessionDesigner,
      placement: PLACEMENT.NONE,
      claim: 'user::player::*',
    },
    {
      exact: true,
      path: '/player/:playerId/gameSession/:id',
      component: SessionDesigner,
      placement: PLACEMENT.NONE,
      claim: 'user::player::*',
    },
    {
      exact: true,
      path: '/playerArchive',
      component: PlayerArchive,
      placement: PLACEMENT.NONE,
      claim: 'user::player::*',
    },
    {
      path: '/player/:id/activities',
      component: ResultsDashboard,
      placement: PLACEMENT.NONE,
      claim: 'user::player::*',
    },
    {
      path: '/player/:id/progressDashboard',
      component: PlayerProgressDashboard,
      placement: PLACEMENT.NONE,
      claim: 'user::player::*',
    },
    {
      path: '/player/:id/dashboard',
      component: PlayerDashboard,
      placement: PLACEMENT.NONE,
      claim: 'user::player::*',
      exact: true,
    },
    {
      path: '/genericAddForm',
      component: GenericAddForm,
      placement: PLACEMENT.NONE,
      claim: 'user::player::*',
      exact: true,
    },
    {
      path: '/player/:id/dashboard/:measurement',
      component: PlayerCardDetail,
      placement: PLACEMENT.NONE,
      claim: 'user::player::*',
      exact: true,
    },
    {
      path: '/player/:id/sessionBank',
      component: PlayerSessionBank,
      placement: PLACEMENT.NONE,
      claim: 'user::player::*',
    },
    {
      path: '/player/:id/teamMembers',
      component: PlayerTeamMembers,
      placement: PLACEMENT.NONE,
      claim: 'user::player::*',
    },
    {
      path: '/player/:id/homePlay',
      component: HomePlay,
      placement: PLACEMENT.NONE,
      claim: 'user::player::*',
    },
    {
      component: TeamMembers,
      exact: true,
      label: 'My Team',
      path: '/team',
      claim: 'user::team::*',
      placement: PLACEMENT.DROPDOWN,
      to: '/team',
    },
    {
      component: TeamMemberForm,
      path: '/teamMember',
      claim: 'user::team::*',
      placement: PLACEMENT.NONE,
      to: '/team',
      exact: true,
    },
    {
      component: TeamMemberForm,
      path: '/teamMember/:id',
      claim: 'user::team::*',
      placement: PLACEMENT.NONE,
      to: '/team',
    },
    {
      path: '/teamMembers',
      component: () => {
        return <Redirect to="/team" />;
      },
      placement: PLACEMENT.NONE,
      claim: 'user::team::*',
    },
    {
      component: MetabaseDashboard,
      exact: true,
      label: 'Stats',
      path: '/analytics',
      claim: 'user::analytics::*',
      placement: PLACEMENT.DROPDOWN,
      to: '/analytics',
    },
    {
      component: TherapyRefusalDashboard,
      exact: true,
      label: 'Therapy Refusals',
      path: '/refusals',
      claim: 'user::analytics::*',
      placement: PLACEMENT.DROPDOWN,
      to: '/refusals',
    },
    {
      path: '/player/archived',
      claim: 'user::player::archived::*',
      component: PlayerArchive,
      exact: true,
      placement: PLACEMENT.NONE,
    },
    {
      component: TournamentCreator,
      exact: true,
      label: 'Tournaments',
      path: '/tournament',
      claim: 'user::tournament::*',
      placement: PLACEMENT.DROPDOWN,
      to: '/tournament',
    },
    {
      component: TournamentEditor,
      exact: true,
      label: 'Add Tournament',
      path: '/tournament/new',
      claim: 'user::tournament::*',
      placement: PLACEMENT.NONE,
    },
    {
      component: TournamentEditor,
      exact: true,
      label: 'Edit Tournament',
      path: '/tournament/:tournamentId',
      claim: 'user::tournament::*',
      placement: PLACEMENT.NONE,
    },
    {
      component: CommunicationCreator,
      exact: true,
      label: 'Communication',
      path: '/communication',
      claim: 'user::communication::*',
      placement: PLACEMENT.DROPDOWN,
      to: '/communication',
    },
    {
      component: CommunicationEditor,
      exact: true,
      label: 'Communication',
      path: '/communication/add',
      claim: 'user::communication::*',
      placement: PLACEMENT.NONE,
      to: '/communication/add',
    },
    {
      component: CommunicationEditor,
      exact: true,
      label: 'Communication',
      path: '/communication/:communicationId/',
      claim: 'user::communication::*',
      placement: PLACEMENT.NONE,
      to: '/communication/:communicationId',
    },
    {
      component: AdminDashboardRedirect,
      exact: true,
      label: 'Admin Dashboard',
      path: '/admin-dashboard',
      claim: 'user::admin-dashboard::*',
      placement: PLACEMENT.DROPDOWN,
      to: '/admin-dashboard',
    },
    {
      component: MasqueradePage,
      exact: true,
      label: 'Masquerade',
      path: '/masquerade',
      claim: 'user::masquerade::*',
      placement: PLACEMENT.DROPDOWN,
      to: '/masquerade',
      hideFooter: true,
    },
    {
      component: PlayerRewards,
      exact: true,
      label: 'Rewards',
      path: '/rewards',
      claim: 'user::profile::*',
      placement: PLACEMENT.NONE,
      to: '/rewards',
      featureToggle: { name: splitsDictionary.GAMIFICATION.name, type: splitsDictionary.GAMIFICATION.traffic_type },
    },
    {
      component: MasqueradePage,
      exact: true,
      label: 'Revert Masquerade',
      path: '/masquerade/:revert',
      claim: 'user::masquerade::revert',
      placement: PLACEMENT.DROPDOWN,
      to: '/masquerade/true',
      hideFooter: true,
    },
    {
      component: () => {
        return <SsoRedirect pathname="/sso/jwt/:token" />;
      },
      label: 'Communication Board',
      path: '/sso/cboard',
      claim: 'user::cboard::*',
      placement: PLACEMENT.NONE,
      to: '/sso/cboard',
      exact: true,
      hideFooter: true,
      featureToggle: { name: 'DC-1765-cboard-integration', type: 'business-group' },
    },
    {
      component: Cboard,
      label: 'Communication Board',
      path: '/communication-board',
      claim: 'user::cboard::*',
      placement: PLACEMENT.DROPDOWN,
      to: '/communication-board',
      exact: true,
      hideFooter: true,
      noMainPadding: true,
      featureToggle: { name: 'DC-1765-cboard-integration', type: 'business-group' },
    },
    {
      component: Cboard,
      label: 'Communication Board',
      path: '/communication-board/:restorativeProgramId',
      claim: 'user::cna-cboard::*',
      placement: PLACEMENT.NONE,
      to: '/communication-board',
      exact: true,
      hideFooter: true,
      noMainPadding: true,
      featureToggle: { name: 'DC-1765-cboard-integration', type: 'business-group' },
    },
    //Care Partner
    {
      component: Wellness,
      label: 'Wellness',
      path: '/wellness/:path',
      claim: 'user::care-partner-wellness::*',
      placement: PLACEMENT.NONE,
      to: '/wellness',
      exact: true,
    },
    //Therapist Wellness
    {
      component: Wellness,
      label: 'Wellness',
      path: '/wellness/:path',
      claim: 'user::therapist-wellness::*',
      placement: PLACEMENT.NONE,
      to: '/wellness',
      exact: true,
    },
    {
      component: Wellness,
      label: 'Group & Concurrent',
      path: '/wellness/group-and-concurrent',
      claim: 'user::therapist-wellness::*',
      placement: PLACEMENT.NAVBAR,
      to: '/wellness/group-and-concurrent',
      exact: true,
      mixPanelEvent: {
        name: 'Therapy_SkillsUI_NavigationBar_Click',
        data: {
          Selection: 'Group & Concurrent',
        },
      },
      featureToggle: {
        name: splitsDictionary.NEW_GROUP_AND_CONCURRENT.name,
        type: splitsDictionary.NEW_GROUP_AND_CONCURRENT.traffic_type,
        treatmentValue: 'on',
      },
      tour: 'group_and_concurrent',
    },
    {
      render: () => <Redirect to="/wellness/group-activities" />,
      path: '/dashboard',
      exact: true,
      placement: PLACEMENT.NONE,
      claim: 'user::care-partner-wellness::*',
      to: '/dashboard',
    },
    {
      component: Wellness,
      label: 'Group Activities',
      path: '/wellness/group-activities',
      claim: 'user::care-partner-wellness::*',
      placement: PLACEMENT.NAVBAR,
      to: '/wellness/group-activities',
      exact: true,
      noMainPadding: true,
    },
    {
      component: Wellness,
      label: 'Individual Activities',
      path: '/wellness/individual-activities',
      claim: 'user::care-partner-wellness::*',
      placement: PLACEMENT.NAVBAR,
      to: '/wellness/individual-activities',
      exact: true,
      noMainPadding: true,
    },
    {
      component: SecurityDashboard,
      exact: true,
      label: 'PHI Access Logs',
      path: '/phi-access-logs',
      claim: 'user::business-group-analytics::*',
      placement: PLACEMENT.DROPDOWN,
      to: '/phi-access-logs',
    },
    {
      component: LogOut,
      exact: true,
      label: 'Log Out',
      path: '/log-out',
      claim: 'user::logOut::*',
      placement: PLACEMENT.DROPDOWN,
      to: '/log-out',
    },
    {
      component: MarbleRedirect,
      exact: true,
      label: 'Academy',
      path: '/wellness/lms',
      claim: 'user::lms::*',
      placement: PLACEMENT.NONE,
      to: '/wellness/lms',
      hideFooter: true,
      featureToggle: { name: 'DC-1606-marble-lms', type: 'business-group' },
    },
    {
      component: MarbleRedirect,
      exact: true,
      label: 'Academy',
      path: '/wellness/:path',
      claim: 'user::lms::*',
      placement: PLACEMENT.NONE,
      to: '/wellness/lms',
      hideFooter: true,
      featureToggle: { name: 'DC-1606-marble-lms', type: 'business-group' },
    },
    {
      component: IframeWebcore,
      exact: true,
      label: 'Just Play',
      path: '/play',
      claim: 'user::singleGame::*',
      placement: PLACEMENT.NAVBAR,
      to: '/play',
      hideFooter: true,
      mixPanelEvent: {
        name: 'Therapy_SkillsUI_NavigationBar_Click',
        data: {
          Selection: 'Just Play',
        },
      },
    },
    {
      component: IframeWebcore,
      exact: true,
      label: 'Play',
      path: '/play/:pathType',
      claim: 'user::singleGame::*',
      placement: PLACEMENT.NONE,
      to: '/play',
      hideFooter: true,
    },

    {
      component: InterventionLaunch,
      exact: true,
      label: 'Intervention',
      path: '/intervention/:functionalSkillId/:playerId/:gameId',
      claim: 'user::singleGame::*',
      placement: PLACEMENT.NONE,
      to: '/intervention',
      hideFooter: true,
    },
    {
      component: IframeWebcore,
      exact: true,
      label: 'Play',
      path: '/play/insights/:pathType/:functional_skill_session_id/:playerId/:gameId',
      claim: 'user::singleGame::*',
      placement: PLACEMENT.NONE,
      to: '/play',
      hideFooter: true,
    },
    {
      component: IframeWebcore,
      exact: true,
      label: 'Play',
      path: '/play/:pathType/:id',
      claim: 'user::singleGame::*',
      placement: PLACEMENT.NONE,
      to: '/play',
      hideFooter: true,
    },
    {
      component: IframeWebcore,
      exact: true,
      label: 'Play',
      path: '/play/wellness/:pathType/:id',
      claim: 'user::care-partner-single-game::*',
      placement: PLACEMENT.NONE,
      to: '/play',
      hideFooter: true,
    },
    {
      component: IframeWebcore,
      exact: true,
      label: 'Play',
      path: '/play/wellness/:pathType/:id',
      claim: 'user::therapist-wellness::*',
      placement: PLACEMENT.NONE,
      to: '/play',
      hideFooter: true,
    },
    {
      component: IframeWebcore,
      exact: true,
      label: 'Play',
      path: '/play/wellness/:pathType/:id',
      claim: 'user::cna-single-game::*',
      placement: PLACEMENT.NONE,
      to: '/play',
      hideFooter: true,
    },
    {
      component: IframeWebcore,
      exact: true,
      label: 'Play',
      path: '/play/wellness/:pathType/:id/:groupId/',
      claim: 'user::wellness-play::*',
      placement: PLACEMENT.NONE,
      to: '/play',
      hideFooter: true,
    },
    {
      component: RemoteTherapySession,
      label: 'Video Conference',
      path: `/remote-therapy-session/`,
      claim: 'player::remote-therapy::*',
      placement: PLACEMENT.NAVBAR,
      to: `/remote-therapy-session/`,
      exact: true,
      noMainPadding: true,
      featureToggle: {
        name: splitsDictionary.REMOTE_THERAPY.name,
        type: splitsDictionary.REMOTE_THERAPY.traffic_type,
        treatmentValue: 'on',
      },
      mixPanelLogClick: {
        platform: PlatformTypes.REMOTE_THERAPY,
        moduleName: 'Therapist Dashboard',
        eventType: MixPanelEventTypes.CLICK,
        pageName: 'Player Dashboard',
        selection: 'Video Conference',
      },
    },
    {
      component: IframeWebcore,
      exact: true,
      label: 'Games',
      path: '/play',
      claim: 'player::singleGame::*',
      placement: PLACEMENT.NAVBAR,
      to: '/play',
      hideFooter: true,
      mixPanelLogClick: {
        platform: PlatformTypes.REMOTE_THERAPY,
        moduleName: 'Therapist Dashboard',
        eventType: MixPanelEventTypes.CLICK,
        pageName: 'Player Dashboard',
        selection: 'Start',
      },
    },
    {
      component: IframeWebcore,
      exact: true,
      label: 'Play',
      path: '/play/:pathType',
      claim: 'player::singleGame::*',
      placement: PLACEMENT.NONE,
      to: '/play',
      hideFooter: true,
    },
    {
      component: IframeWebcore,
      exact: true,
      label: 'Play',
      path: '/play/:pathType/:id',
      claim: 'player::singleGame::*',
      placement: PLACEMENT.NONE,
      to: '/play',
      hideFooter: true,
    },
    {
      component: ResetPassword,
      exact: true,
      label: 'Reset Password',
      path: '/reset-password',
      claim: 'user::resetPassword::*',
      placement: PLACEMENT.NONE,
      to: '/reset-password',
    },
    {
      component: PasswordSuccess,
      exact: true,
      label: 'Reset Password',
      path: '/password-success',
      claim: 'user::profile::*',
      placement: PLACEMENT.NONE,
      to: '/password-success',
    },

    {
      component: RemoteTherapySession,
      label: 'Remote Therapy Session',
      path: '/remote-therapy-session/:id',
      claim: 'user::remote-therapy::*',
      placement: PLACEMENT.NONE,
      to: '/remote-therapy-session/:id',
      exact: true,
      noMainPadding: true,
      featureToggle: {
        name: splitsDictionary.REMOTE_THERAPY.name,
        type: splitsDictionary.REMOTE_THERAPY.traffic_type,
        treatmentValue: 'on',
      },
    },
    {
      component: RestorativePlayerList,
      label: 'Restorative Programs',
      path: '/dashboard',
      exact: true,
      claim: 'user::restorative-player-list::*',
      placement: PLACEMENT.NAVBAR,
      to: '/dashboard',
      noMainPadding: true,
    },
    {
      component: Wellness,
      label: 'Restorative Wellness',
      path: '/wellness/:path',
      claim: 'user::cna-wellness::*',
      placement: PLACEMENT.NONE,
      exact: true,
      to: '/wellness',
    },
    {
      component: Wellness,
      label: 'Group Activities',
      path: '/wellness/restorative-group-activities',
      claim: 'user::cna-wellness::*',
      placement: PLACEMENT.NAVBAR,
      to: '/wellness/restorative-group-activities',
      exact: true,
      noMainPadding: true,
    },
    {
      component: Wellness,
      label: 'Individual Activities',
      path: '/wellness/restorative-individual-activities',
      claim: 'user::cna-wellness::*',
      placement: PLACEMENT.NAVBAR,
      to: '/wellness/restorative-individual-activities',
      exact: true,
      noMainPadding: true,
    },
  ];
};

export default routes;
